import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';
import TextareaInput from './TextareaInput';
import DeleteButton from '../Buttons/DeleteButton';

const BulletPointList = ({ listItems, addListItem, contentIndex, onChangeWrap, deleteInput }) => {
  const handleKeyPress = (e, nestedIndex) => {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter
      e.preventDefault();
      addListItem(contentIndex, nestedIndex);
    }
  };

  return (
    <ul className="freeform-input-group unordered-list-input-group faux-list">
      {listItems &&
        listItems.map((bulletPoint, index) => (
          <li key={index} className="list-item-input unordered-list-input d-flex align-items-center">
            <TextareaInput
              classes="w-100"
              name={`main_content[${contentIndex}].data[${index}].text`}
              value={bulletPoint.text}
              placeholder="Click to add a bullet point"
              onChange={onChangeWrap({ type: `bullet_list`, index })}
              onKeyPress={e => handleKeyPress(e, index)}
              autoResize
            />
            {deleteInput &&
              <DeleteButton classes="m-l-2 m-r-0" onClick={(e) => { e.preventDefault(); deleteInput(contentIndex, index); }} />
            }
          </li>
        ))
      }

      <Button size="s" onClick={(e) => { e.preventDefault(); addListItem(contentIndex); }}>Add new bullet point</Button>
    </ul>
  );
};

BulletPointList.propTypes = {
  listItems: PropTypes.array.isRequired,
  addListItem: PropTypes.func,
  contentIndex: PropTypes.number,
  onChangeWrap: PropTypes.func.isRequired,
  deleteInput: PropTypes.func,
};

export default BulletPointList;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/UnorderedList.js